// inv: front-end/src/modules/utils/DisasterInvMathUtils.tsからの移行

/**
 * 指定した経度、緯度からクアッドキーを計算する
 * param latitude 緯度
 * param longitude 経度
 * param zoom ズームレベル
 * @returns クアッドキー
 */
export const latLonToQuadKey = (latitude: number, longitude: number, zoom: number): string => {
  const tileX = Math.floor(((longitude + 180) / 360) * Math.pow(2, zoom))
  const tileY = Math.floor(
    ((1 -
      Math.log(Math.tan((latitude * Math.PI) / 180) + 1 / Math.cos((latitude * Math.PI) / 180)) /
        Math.PI) /
      2) *
      Math.pow(2, zoom)
  )
  let quadKey = ''
  for (let i = zoom; i > 0; i--) {
    const mask = 1 << (i - 1)
    let digit = 0
    if ((tileX & mask) !== 0) {
      digit = 1
    }
    if ((tileY & mask) !== 0) {
      digit += 2
    }
    quadKey += digit.toString()
  }
  return quadKey
}
